export default function QueryBuilder() {
  const _where = [];

  this.where = function(field, operator, value) {
    _where.push([field, operator, value]);
    return this;
  }

  this.getClauses = function() {
    return _where;
  }

  this.isEqual = function(queryBuilder) {
    const clauses = queryBuilder.getClauses();

    if (clauses.length !== _where.length) {
      return false;
    }

    for (let i = 0; i < clauses.length; i++) {
      const clause = clauses[i];
      const currentClause = _where[i];

      if (clause[0] !== currentClause[0] || clause[1] !== currentClause[1] || clause[2] !== currentClause[2]) {
        return false;
      }
    }

    return true;
  }

  this.from = function(queryBuilder) {
    const newQueryBuilder = new QueryBuilder();

    for (const where of queryBuilder.getClauses()) {
      newQueryBuilder._where.push(where);
    }

    return newQueryBuilder;
  }

  this.inject = function(query) {
    _where.forEach((where) => {
      query = query.where(where[0], where[1], where[2]);
    });

    return query;
  }
}